<template>
   <div
   class="grid-item"
   :class="`grid-${size}`"
   v-scroll-reveal>

      <div class="video"
      v-if="gif">
        <iframe
        frameborder="0"
        allowfullscreen=""
        scrolling="no"
        :src="`https://onelineplayer.com/player.html?autoplay=true&loop=true&autopause=false&muted=true&url=https%3A%2F%2Fvimeo.com%2F${videoID}&poster=&time=false&progressBar=false&playButton=false&overlay=false&muteButton=false&fullscreenButton=false&style=light&logo=false&quality=1080p`"
        style="position: absolute; height: 100%; width: 100%; left: 0px; top: 0px;" />
      </div>

      <div class="video"
      v-else>
        <iframe
        frameborder="0"
        allowfullscreen=""
        scrolling="no"
        :src="`https://onelineplayer.com/player.html?autoplay=false&loop=false&autopause=false&muted=false&url=https%3A%2F%2Fvimeo.com%2F${videoID}&time=true&progressBar=true&playButton=true&overlay=true&muteButton=true&fullscreenButton=true&style=light&logo=false&quality=1080p&buttonColor=%23ffffff&buttonSize=50`"
        style="position: absolute; height: 100%; width: 100%; left: 0px; top: 0px;" />
      </div>

   </div>
</template>

<script>
export default {
  props: {
    'size': { type: String, default: '25' },
    'videoID': { type: String },
    'gif': { type: Boolean, default: false }
  }

}
</script>

<style <style lang="scss" scoped>
.grid-item {

  .video {
    padding-top: 56.25%;
    position: relative;
    overflow: hidden;
  }
}
</style>
